if (!customElements.get('karo-teklifleri')) {
  customElements.define('karo-teklifleri', class extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-karo-variants]').textContent);
      this.variant = JSON.parse(this.querySelector('[data-karo-selected]').textContent);
      this.productInfo = this.closest('product-info');
      this.amount = Math.max(1, Number(this.quantity?.value) || 1);
      this.onChange = (event) => {
        if (this.contains(event.target) && event.target.matches('input[type="radio"]')) {
          const quantity = this.quantity;
          if (quantity) {
            quantity.value = event.target.value;
            quantity.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        if (event.target === this.quantity) {
          this.amount = Math.max(1, Number(this.quantity.value) || 1);
          this.update();
        }
      };
      this.productInfo?.addEventListener('change', this.onChange);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.section || !data.variant) return;
        this.variant = data.variant;
        if (this.quantity) this.quantity.value = this.amount;
        this.update();
      });
      this.update();
    }
    disconnectedCallback() {
      this.productInfo?.removeEventListener('change', this.onChange);
      this.unsubscribe?.();
    }
    get quantity() { return this.productInfo?.querySelector('.quantity__input'); }
    money(cents) {
      return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(cents / 100) + ' TL';
    }
    unit(minimum) {
      if (this.dataset.family === 'cakil') return { 1: 50000, 5: 45000, 10: 40000, 20: 35000 }[minimum];
      const square = this.variant.options.includes('15 × 15 cm');
      return (square
        ? { 1: 59900, 6: 52000, 12: 45000, 20: 37000 }
        : { 1: 39900, 6: 34900, 12: 30000, 20: 24900 })[minimum];
    }
    update() {
      const amount = Math.max(1, Number(this.quantity?.value) || 1);
      const thresholds = this.dataset.family === 'cakil' ? [1, 5, 10, 20] : [1, 6, 12, 20];
      const tier = thresholds.filter(minimum => amount >= minimum).pop();
      this.querySelectorAll('[data-unit-price]').forEach((node) => {
        node.textContent = this.money(this.unit(Number(node.dataset.unitPrice)));
      });
      this.querySelectorAll('[data-original-price-value]').forEach((node) => {
        node.textContent = this.money(this.variant.price);
      });
      this.querySelectorAll('[data-saving]').forEach((node) => {
        const minimum = Number(node.dataset.saving);
        node.textContent = minimum === 1 ? 'Tekli fiyat' : '%' + Math.round((1 - this.unit(minimum) / this.variant.price) * 100) + ' indirim';
      });
      this.querySelectorAll('input[type="radio"]').forEach((input) => { input.checked = Number(input.value) === tier; });
      this.querySelector('.karo-offers__summary').textContent = amount + ' adet · ' + this.money(this.unit(tier) * amount) + ' toplam';
    }
  });
}
